// extracted by mini-css-extract-plugin
export default {"button":"BookCoverTemplateAction_button__+OS5B","active":"BookCoverTemplateAction_active__NGDs2","modalContentWrapper":"BookCoverTemplateAction_modalContentWrapper__XXAFT"};